import Icon from "@mui/material/Icon/Icon";
import moment from "moment";
import { isInterventionTerminated } from "./interventionStatusActions";
import {
    PAUSED_INTERVENTIONS_TYPE_ID,
    SET_DISPLAY_ONLY_IF_GOT_CERFA,
    SET_SELECTED_TECHNICIAN_ID,
} from "./interventionConstants";

export function setDisplayOnlyIfGotCerfaAction(displayOnlyIfGotCerfa) {
    return {
        type: SET_DISPLAY_ONLY_IF_GOT_CERFA,
        displayOnlyIfGotCerfa,
    };
}

export function setSelectedTechnicianIdAction(selectedTechnicianId) {
    return {
        type: SET_SELECTED_TECHNICIAN_ID,
        selectedTechnicianId,
    };
}

export function setDisplayOnlyIfGotCerfa(displayOnlyIfGotCerfa) {
    return (dispatch) => {
        dispatch(setDisplayOnlyIfGotCerfaAction(displayOnlyIfGotCerfa));
    };
}

export function setSelectedTechnicianId(selectedTechnicianId) {
    return (dispatch) => {
        dispatch(setSelectedTechnicianIdAction(selectedTechnicianId));
    };
}

export function sort(interventions, sortingMode) {
    return interventions.sort(sortingMode.sortFunction);
}

export function filter(
    interventions,
    displayMode,
    selectedDay,
    displayEndedInterventions,
    searchInput,
    customerId,
    excludeCurrentInterventionId
) {
    let filteredInterventions = interventions.filter((intervention) => {
        if (searchInput) {
            if (intervention.name.includes(searchInput)) {
                return true; //On ne prend pas en compte les autres filtres => la recherche par numéro d'OT override tout
            }

            return false;
        }

        if (customerId !== null && customerId !== undefined)
            if (!intervention.delivery_customer_id || intervention.delivery_customer_id.id !== customerId) return false;

        if (excludeCurrentInterventionId && intervention.id === excludeCurrentInterventionId) return false;

        if (!displayEndedInterventions && isInterventionTerminated(intervention.state, intervention.internalState))
            return false;

        return displayMode.filterFunction(intervention, selectedDay);
    });

    return filteredInterventions;
}

export function getDisplayModes() {
    return [
        {
            id: 0,
            icon: <Icon>today</Icon>,
            label: "Quotidien",
            filterFunction: function (intervention, selectedDay) {
                var datePlannedStart = moment(intervention.date_planned_start).format("YYYY-MM-DD");
                var today = selectedDay.format("YYYY-MM-DD");
                return datePlannedStart === today;
            },
        },
        {
            id: 1,
            icon: <Icon>playlist_play</Icon>,
            label: "A venir",
            filterFunction: function (intervention) {
                var datePlannedStart = moment(intervention.date_planned_start).format("YYYY-MM-DD");
                var today = moment().format("YYYY-MM-DD");
                return datePlannedStart > today;
            },
        },
        {
            id: 2,
            icon: <Icon>timelapse</Icon>,
            label: "En retard",
            filterFunction: function (intervention) {
                var datePlannedStart = moment(intervention.date_planned_start).format("YYYY-MM-DD");
                var today = moment().format("YYYY-MM-DD");
                let statusNotFinished = !isInterventionTerminated(intervention.state, intervention.internalState);
                return statusNotFinished && datePlannedStart < today;
            },
        },
        {
            id: PAUSED_INTERVENTIONS_TYPE_ID,
            icon: <Icon>pause</Icon>,
            label: "Interrompues",
            filterFunction: function (intervention) {
                let statusInterrupted = intervention.internalState === "paused";
                return statusInterrupted;
            },
        },
        {
            id: 4,
            icon: <Icon>playlist_add_check</Icon>,
            label: "Terminées",
            filterFunction: function (intervention) {
                return isInterventionTerminated(intervention.state, intervention.internalState);
            },
        },
        {
            id: 5,
            icon: <Icon>list</Icon>,
            label: "Toutes",
            filterFunction: function () {
                return true;
            },
        },
    ];
}

export function getSortingModes() {
    return [
        {
            id: 0,
            icon: <Icon>access_time</Icon>,
            label: "Tri par date",
            sortFunction: function (interventionA, interventionB) {
                if (interventionA.internalState === "started") return -1;

                if (interventionB.internalState === "started") return 1;

                if (interventionA.date_planned_start < interventionB.date_planned_start) return -1;

                if (interventionA.date_planned_start > interventionB.date_planned_start) return 1;

                return 0;
            },
        },
        {
            id: 1,
            icon: <Icon>person</Icon>,
            label: "Tri par client",
            sortFunction: function (interventionA, interventionB) {
                if (interventionA.internalState === "started") return -1;

                if (interventionB.internalState === "started") return 1;

                if (!interventionA.delivery_customer_id || !interventionB.delivery_customer_id) return 0;

                if (interventionA.delivery_customer_id.name < interventionB.delivery_customer_id.name) return -1;

                if (interventionA.delivery_customer_id.name > interventionB.delivery_customer_id.name) return 1;

                return 0;
            },
        },
        {
            id: 2,
            icon: <Icon>format_list_numbered</Icon>,
            label: "Tri par num OT",
            sortFunction: function (interventionA, interventionB) {
                if (interventionA.internalState === "started") return -1;

                if (interventionB.internalState === "started") return 1;

                if (interventionA.name < interventionB.name) return -1;

                if (interventionA.name > interventionB.name) return 1;

                return 0;
            },
        },
        {
            id: 3,
            icon: <Icon>location_on</Icon>,
            label: "Tri par ville",
            sortFunction: function (interventionA, interventionB) {
                if (interventionA.internalState === "started") return -1;

                if (interventionB.internalState === "started") return 1;

                let addressA;
                let addressB;

                if (interventionA.delivery_address_id && interventionB.delivery_address_id) {
                    addressA = interventionA.delivery_address_id;
                    addressB = interventionB.delivery_address_id;
                } else if (interventionA.delivery_customer_id && interventionB.delivery_customer_id) {
                    addressA = interventionA.delivery_customer_id;
                    addressB = interventionB.delivery_customer_id;
                }

                if (!addressA || !addressB) return 0;

                if (addressA.city < addressB.city) return -1;

                if (addressA.city > addressB.city) return 1;

                return 0;
            },
        },
    ];
}
